import type { CanvasJSONLikeObject } from '@doer/frontend-components/creativity-editor';
import type { FontWeight } from '../text/text-defaults';

export interface BenefitLabelOpts {
  pieceId: string;
  text: string;
  fontSize: number;
  fontWeight?: FontWeight;
  paddingX?: number;
  paddingY?: number;
  position: { left: number; top: number };
  pillFill?: string;
  borderRadius?: number;
}

export function buildBenefitLabel(opts: BenefitLabelOpts): CanvasJSONLikeObject {
  const {
    pieceId,
    text,
    fontSize,
    fontWeight = 700,
    position,
    pillFill = 'rgb(255,112,206)',
    borderRadius = 18
  } = opts;
  const paddingX = opts.paddingX ?? 24;
  const paddingY = opts.paddingY ?? 8;
  return {
    pieceId,
    type: 'IText',
    version: '7.1.0',
    text,
    fontSize,
    fontWeight,
    fontFamily: 'DM Sans',
    fontStyle: 'normal',
    lineHeight: 1.16,
    charSpacing: 0,
    textAlign: 'center',
    styles: [],
    pathStartOffset: 0,
    pathSide: 'left',
    pathAlign: 'baseline',
    underline: false,
    overline: false,
    linethrough: false,
    textBackgroundColor: '',
    direction: 'ltr',
    textDecorationThickness: 66.667,
    minWidth: 20,
    splitByGrapheme: false,
    originX: 'center',
    originY: 'center',
    left: position.left,
    top: position.top,
    fill: '#FFFFFF',
    stroke: null,
    strokeWidth: 0,
    objectCaching: true,
    selectable: true,
    evented: true,
    pill: {
      fill: pillFill,
      borderRadius,
      paddingX,
      paddingY,
      minWidth: 0,
      stroke: '#000000',
      strokeWidth: 0
    }
  };
}
